import React from "react";
import PropTypes from "prop-types";

import NewsListLayout from "./NewsListLayout";
import NewsDetailsLayout from "./NewsDetailsLayout";

const parseNewsData = (data) => {
  if (!data) {
    return null;
  }

  if (typeof data === "object") {
    return data;
  }

  if (typeof data !== "string") {
    return null;
  }

  try {
    return JSON.parse(data);
  } catch (error) {
    // Some TYPO3 responses return an empty itemTotalCount value.
    const repairedData = data.replace(/"itemTotalCount"\s*:\s*}/g, '"itemTotalCount": 0}');

    try {
      return JSON.parse(repairedData);
    } catch (repairError) {
      return null;
    }
  }
};

const NewsLayout = ({ content, pageInfo }) => {
  const normalizedContent = {
    ...content,
    colPos0: content.colPos0?.map((element) => {
      if (element.type !== "news_pi1") {
        return element;
      }

      return {
        ...element,
        content: {
          ...element.content,
          data: parseNewsData(element.content?.data),
        },
      };
    }),
  };

  const renderNewsLayout = () => {
    const firstNewsElement = normalizedContent.colPos0?.find(
      (element) => element.type === "news_pi1",
    );
    const action = firstNewsElement?.content?.data?.settings?.action;

    if (action === "list") {
      return <NewsListLayout content={normalizedContent} pageInfo={pageInfo} />;
    }

    if (action === "detail") {
      return <NewsDetailsLayout content={normalizedContent} pageInfo={pageInfo} />;
    }

    if (normalizedContent.colPos0) {
      // Keep page render resilient even if news payload is malformed.
      return <NewsListLayout content={normalizedContent} pageInfo={pageInfo} />;
    }

    return <></>;
  };

  return renderNewsLayout();
};

NewsLayout.propTypes = {
  content: PropTypes.instanceOf(Object),
  pageInfo: PropTypes.instanceOf(Object),
};

export default NewsLayout;
